/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-06-29 11:02:51
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title4 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import FormChart from './FormChart';

class P18 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],

      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }

  fillColor = (tableColumns) => {
    const border = `none`
    return tableColumns.map((item, index) => {
      return {
        ...item,
        style: (_, i) => {
          return {
            ...item.style,
            height: 50,
            fontSize: 16,
            textAlign: 'center',
            fontWeight: 'bold',
            color: '#000',
            background: '#fff',
            borderRight: border,
            borderBottom: i !== 0 ? '1px solid #000' : border,
          }
        },
        colStyle: (_, ii, i) => {
          return {
            height: 50,
            fontSize: 16,
            textAlign: 'center',
            fontWeight: index === 0 ? 'bold' : 'normal',
            color: '#000',
            background: '#fff',
            borderRight: border,
            borderBottom: i !== 0 ? '1px solid #000' : border,
          }
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, tableColumns, tableList, chartColorList } = this.state;
    return (
      <Stage>
        <Title4 pageNumber="4.2">安踏｜各平台好感度分析</Title4>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>
              用户在微博平台的活跃度最高，内容条数高达211,373条，占比67.32%
            </div>
            <div contentEditable className={s.des}>
              监测期内，全媒体渠道共发布与安踏相关的313,977条内容（不含评论跟帖）。各渠道平台的传播中，主要以正向和中性内容为主，负面内容相对较少。负面内容主要在微博、网络媒体、大众媒体和泛财经类媒体上发酵，中央级媒体也出现部分负面声音，对品牌口碑的影响较大。
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                style={{ width: '100%', height: '100%' }}
                formContent={<FormChart onChange={values => this.setState({ ...values })} />}>
                <Chart options={setChart({
                  label: chartTitle,
                  list: chartList,
                  color: chartColorList
                })} />
              </TooltipDrawer>
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable columns={this.fillColor(tableColumns)} data={tableList} style={{ boxShadow: 'none' }} />
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P18);



// WEBPACK FOOTER //
// src/routes/visualChart/P18/index.js